window.Vue = require('vue');
window.onload = function () {
    Vue.component('calculate', {
        data: function() {
            return {
                values: {
                    one: {
                    interestPaid: null, 
                    rep: null,
                    totalCost: null,
                    },
                    three: {
                        interestPaid: null, 
                        rep: null,
                        totalCost: null,
                    },
                    six: {
                        interestPaid: null, 
                        rep: null,
                        totalCost: null,
                    } 
                },
                loanAmount: '',
            }
        },

        methods: {
            setRepayment() {
                loanAmount = this.loanAmount;
            
                var interestPaidInitial = {
                    'one': 24.00,
                    'three': 51.40,
                    'six': 98.64
                };

                var interestPaidObject = {}; 

                const object = { one: 1, three: 3, six: 6 };
        
                for (const property in interestPaidInitial) {
                    interestPaidObject[property] = interestPaidInitial[property] * (loanAmount / 100);
                    monthTotalCost = interestPaidObject[property] + parseInt(loanAmount);
                    monthAverageRep = monthTotalCost / `${object[property]}`;

                    interestPaid = interestPaidObject[property].toFixed(2);
                    monthTotalCost = monthTotalCost.toFixed(2);
                    monthAverageRep = monthAverageRep.toFixed(2);
                    this.values[property] = {
                        'rep': monthAverageRep,
                        'interestPaid': interestPaid,
                        'totalCost': monthTotalCost,
                    };
                }
            }
        },
        template:`
        <div>
            <div class="grey-box bg-primary-purple-3 p-6 flex flex-col md:flex-row w-full">
                <div class="w-full pt-3 mb-2">
                    <span class="text-lg">Loan Amount (£):</span>
                </div>
                <div class="form-input-inner w-full mr-8 mb-5 sm:mb-0">
                    <div class="input-wrapper input-wrapper-alt w-full relative">
                        <input type="tel" name="loan_calc" id="loanAmount" v-model='loanAmount' class="w-full currency" v-number-only="true" maxlength="4" />
                    </div>
                </div>
                <button type="button" href="" id="repaymentBtn" @click="setRepayment" class="button btn-primary-purple small-mobile btn-chevron-white btn-chevron text-white px-6 sm:px-7 py-4 rounded text-sm font-bold text-lg flex mx-auto w-full sm:w-auto items-center justify-center">Calculate</button>
            </div>
            <div id="repayment-table">
                <table class="table-fixed mt-8">
                    <thead>
                        <tr class="bg-primary-grey w-full">
                        <th class="w-full py-2"> Repayment Schedule</th>
                        <th class="w-full px-4 py-2">1 Month</th>
                        <th class="px-4 py-2">3 Month</th>
                        <th class="px-4 py-2">6 Month</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td class="bg-primary-purple-3 border px-4 py-2">Average Monthly Repayment</td>
                        <td class="border px-4 py-2" v-text="values.one.rep"></td>
                        <td class="border px-4 py-2" v-text="values.three.rep"></td>
                        <td class="border px-4 py-2" v-text="values.six.rep"></td>
                        </tr>
                        <tr class="bg-gray-100">
                        <td class="bg-primary-purple-3 border px-4 py-2">Interest Paid</td>
                        <td class="border px-4 py-2" v-text="values.one.interestPaid"></td>
                        <td class="border px-4 py-2" v-text="values.three.interestPaid"></td>
                        <td class="border px-4 py-2" v-text="values.six.interestPaid"></td>
                        </tr>
                        <tr>
                        <td class="bg-primary-purple-3 border px-4 py-2">Total Cost</td>
                        <td class="border px-4 py-2" v-text="values.one.totalCost"></td>
                        <td class="border px-4 py-2" v-text="values.three.totalCost"></td>
                        <td class="border px-4 py-2" v-text="values.six.totalCost"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        `
    });

    if ($(".loan-calculator")[0]) {
        new Vue({
            el: '.loan-calculator',
            data: {
            }
        });
    }
}

Vue.directive('numberOnly', {
    bind: function (element, binding) {
        if (binding.value) {
            element.inputHandler = function (event) {
                if (element.value) {
                    element.value = element.value.replace(/\D+/, '');
                }
            };
            element.keyDownHandler = function (event) {
                if (!(/[0-9]|Arrow|Tab|Enter|Backspace|Delete/i.test(event.key)) && !event.metaKey) {
                    event.preventDefault();
                }
            };
            element.addEventListener('input', element.inputHandler);
            element.addEventListener('keydown', element.keyDownHandler);
        }
    },
    unbind: function (element, binding) {
        element.removeEventListener('input', element.inputHandler);
        element.removeEventListener('keydown', element.keyDownHandler);
    }
});